import type { FormatTimeOptions } from '@/util/date';
import { isSameDay } from 'date-fns';
import FormatDate from './FormatDate';

interface TimePeriodProps {
  from: Date;
  to: Date;
  showDates?: 'always' | 'never' | 'different';
  showTimes?: 'always' | 'never';
  timeOptions?: FormatTimeOptions;
}

const TimePeriod = ({
  from,
  to,
  showDates = 'different',
  showTimes = 'always',
  timeOptions = { timeStyle: 'short' },
}: TimePeriodProps) => {
  const showFromDate = ['always', 'different'].includes(showDates);
  const showToDate =
    showDates === 'always' ||
    (showDates === 'different' && !isSameDay(from, to));

  return (
    <>
      <FormatDate
        date={from}
        timeOptions={timeOptions}
        showDate={showFromDate}
        showTime={showTimes === 'always'}
      />{' '}
      &rarr;{' '}
      <FormatDate
        date={to}
        timeOptions={timeOptions}
        showDate={showToDate}
        showTime={showTimes === 'always'}
      />
    </>
  );
};

export default TimePeriod;
